/* Ce que partagent les panneaux de la page : libellés, mises en forme, journal des étapes. */

export const POLL_INTERVAL_MS = 1500;

export const PHASES = {
  analyse: 'Analyse',
  classes: 'Rechargement des classes',
  code: 'Sélection de séries',
  nettoyage: 'Nettoyage',
  purge: 'Suppression',
  resync: 'Resynchronisation Edifice',
};

export const AUDIT_ROWS = [
  { key: 'etabCibles', label: 'Établissements ciblés' },
  { key: 'etabPurges', label: 'Établissements supprimés' },
  { key: 'classesCibles', label: 'Classes ciblées' },
  { key: 'classesProtegees', label: 'Classes conservées' },
  { key: 'classesPurgees', label: 'Classes supprimées' },
  { key: 'enseignantsCibles', label: 'Enseignants ciblés' },
  { key: 'enseignantsActifs', label: 'Enseignants actifs depuis la rentrée' },
  { key: 'enseignantsProteges', label: 'Enseignants conservés' },
  { key: 'enseignantsPurges', label: 'Enseignants supprimés' },
  { key: 'elevesCibles', label: 'Élèves ciblés' },
  { key: 'elevesPurges', label: 'Élèves supprimés' },
  { key: 'parentsPurges', label: 'Parents supprimés' },
  { key: 'assignationsPurgees', label: 'Assignations supprimées' },
];

export const CODE_ROWS = [
  { key: 'enseignants', label: 'Enseignants concernés' },
  { key: 'episodesAncienCode', label: 'Épisodes de l’ancien code' },
  { key: 'episodesNouveauCode', label: 'Épisodes du nouveau code' },
  { key: 'episodesRepris', label: 'Épisodes repris des deux sélections' },
  { key: 'deblocagesARetirer', label: 'Déblocages à retirer' },
  { key: 'rattachementsARetirer', label: 'Rattachements à retirer' },
  { key: 'deblocagesAAjouter', label: 'Déblocages à ajouter' },
  { key: 'rattachementsAAjouter', label: 'Rattachements à ajouter' },
];

export const formatNumber = n => (typeof n === 'number' ? n.toLocaleString('fr-FR') : n);

export const formatDuration = ms => {
  if (ms === undefined || ms === null) return '';
  const seconds = Math.round(ms / 1000);
  if (seconds < 60) return `${seconds} s`;
  return `${Math.floor(seconds / 60)} min ${String(seconds % 60).padStart(2, '0')}`;
};

/*
 * Pendant la purge, le serveur envoie le nombre de lignes attendu : on s'en sert comme
 * dénominateur. Sans lui, l'avancement ne se compterait qu'en étapes, et une table de
 * 550 000 lignes resterait figée sur le même pourcentage.
 */
export const percentOf = progress => {
  if (!progress) return 0;
  if (progress.overallExpected > 0) return Math.min(99, Math.round((progress.overallDone * 100) / progress.overallExpected));
  if (progress.total > 0) return Math.round((((progress.done ?? progress.step) || 0) * 100) / progress.total);
  return 0;
};

export const describeProgress = progress => {
  if (!progress) return 'Démarrage…';

  const phase = PHASES[progress.phase] || progress.phase;
  const label = progress.label || '';

  if (progress.expected > 0) return `${phase} — ${label} : ${formatNumber(progress.done)} / ${formatNumber(progress.expected)}`;
  if (progress.total > 0 && progress.done !== undefined)
    return `${phase} — ${label} : ${formatNumber(progress.done)} / ${formatNumber(progress.total)}`;
  if (progress.step) return `${phase} — ${label} (${progress.step}/${progress.total})`;
  return `${phase} — ${label}`;
};

export const secondsSince = (iso, now) => (iso ? Math.max(0, Math.round((now - new Date(iso).getTime()) / 1000)) : null);

export const describeHeartbeat = (job, now) => {
  const age = secondsSince(job.lastHeartbeatAt, now);
  if (age === null) return 'En attente du serveur…';
  return `serveur actif il y a ${age} s`;
};

export const KIND_LABELS = {
  classes: 'Rechargement des classes',
  code: 'Sélection de séries',
  transition: 'Transition d’année',
};
